import { render } from "./MigrateMei.vue?vue&type=template&id=3bc1e048&scoped=true"
import script from "./MigrateMei.vue?vue&type=script&lang=js"
export * from "./MigrateMei.vue?vue&type=script&lang=js"

import "./MigrateMei.vue?vue&type=style&index=0&id=3bc1e048&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3bc1e048"]])

export default __exports__